export default __webpack_public_path__ + "static/media/Hobbies.b6ca5f35.png";